import { get, post } from '../util/http';
import { ENDPOINTS } from '../util/endpoints';

export const projectService = {
  list: (params) => get(ENDPOINTS.projects.list, { params }),
  syncAllPartners: () => post(ENDPOINTS.projects.syncAll),
  syncPartner: (partnerUuid) => post(ENDPOINTS.projects.syncPartner(partnerUuid)),
  syncProjectPoints: (projId) => post(ENDPOINTS.projects.syncProjectPoints(projId)),
};
